import { render, staticRenderFns } from "./PageWorldPortal.vue?vue&type=template&id=155c50dd&scoped=true&"
import script from "./PageWorldPortal.vue?vue&type=script&lang=js&"
export * from "./PageWorldPortal.vue?vue&type=script&lang=js&"
import style0 from "./PageWorldPortal.vue?vue&type=style&index=0&id=155c50dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155c50dd",
  null
  
)

export default component.exports